(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hircan-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hircan-delivery')) {
  customElements.define('hircan-delivery', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.message = this.querySelector('.HircanDelivery__Message');
      this.result = this.querySelector('.HircanDelivery__Result');
      this.strings = JSON.parse(this.querySelector('[data-delivery-strings]').textContent);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => {
        this.request?.abort();
        this.request = null;
        this.button.disabled = false;
        this.button.textContent = this.strings.calculate;
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
        this.result.hidden = true;
        this.message.hidden = true;
        this.input.removeAttribute('aria-invalid');
      }, options);
      this.input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (!this.button.disabled) this.lookup();
      }, options);
      this.button.addEventListener('click', () => this.lookup(), options);
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
    showMessage(text, invalid = false) {
      this.message.textContent = text;
      this.message.hidden = false;
      this.input.toggleAttribute('aria-invalid', invalid);
      if (invalid) this.input.setAttribute('aria-invalid', 'true');
    }
    todayInBrazil() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone:'America/Sao_Paulo', year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date());
      const part = type => Number(parts.find(item => item.type === type).value);
      return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
    }
    holidays(year) {
      const fixed = ['01-01','04-21','05-01','09-07','10-12','11-02','11-15','11-20','12-25'];
      const dates = new Set(fixed.map(day => year + '-' + day));
      // Gregorian Easter: Good Friday is two days earlier.
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const easterMonth = Math.floor((h + l - 7 * m + 114) / 31);
      const easterDay = (h + l - 7 * m + 114) % 31 + 1;
      const goodFriday = new Date(Date.UTC(year, easterMonth - 1, easterDay - 2, 12));
      dates.add(goodFriday.toISOString().slice(0,10));
      return dates;
    }
    addBusinessDays(start, count) {
      const date = new Date(start.getTime());
      const calendars = new Map();
      let added = 0;
      while (added < count) {
        date.setUTCDate(date.getUTCDate() + 1);
        const year = date.getUTCFullYear();
        if (!calendars.has(year)) calendars.set(year, this.holidays(year));
        const day = date.getUTCDay();
        if (day !== 0 && day !== 6 && !calendars.get(year).has(date.toISOString().slice(0,10))) added++;
      }
      return date;
    }
    updateDeliveryDates() {
      const today = this.todayInBrazil();
      const first = this.addBusinessDays(today, 3);
      const standardLast = this.addBusinessDays(today, 15);
      const expressLast = this.addBusinessDays(today, 12);
      const format = new Intl.DateTimeFormat('pt-BR', { day:'2-digit', month:'2-digit', timeZone:'UTC' });
      this.querySelector('[data-delivery-dates]').textContent = format.format(first) + ' a ' + format.format(standardLast);
      this.querySelector('[data-express-delivery-dates]').textContent = format.format(first) + ' a ' + format.format(expressLast);
    }
    async lookup() {
      const cep = this.input.value.replace(/\D/g, '');
      this.result.hidden = true;
      if (!/^\d{8}$/.test(cep)) { this.showMessage(this.strings.invalid, true); this.input.focus(); return; }
      this.input.removeAttribute('aria-invalid');
      this.request?.abort();
      const request = this.request = new AbortController();
      const timer = setTimeout(() => request.abort('timeout'), 10000);
      this.button.disabled = true;
      this.button.textContent = this.strings.loading;
      this.showMessage(this.strings.loading);
      try {
        const response = await fetch('https://viacep.com.br/ws/' + cep + '/json/', { signal:request.signal, credentials:'omit', referrerPolicy:'no-referrer' });
        if (!response.ok) throw new Error('postcode_lookup');
        const address = await response.json();
        if (this.request !== request || !this.isConnected) return;
        if (address.erro || !address.localidade || !address.uf) { this.showMessage(this.strings.notFound, true); return; }
        this.querySelector('[data-delivery-destination]').textContent = address.localidade + ' / ' + address.uf + ' · ' + cep.slice(0,5) + '-' + cep.slice(5);
        this.updateDeliveryDates();
        this.result.hidden = false;
        this.message.hidden = true;
      } catch(error) {
        if (this.request === request && this.isConnected && (!request.signal.aborted || request.signal.reason === 'timeout')) this.showMessage(this.strings.error);
      } finally {
        clearTimeout(timer);
        if (this.request === request) { this.button.disabled = false; this.button.textContent = this.strings.calculate; }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
